import {AppSettings} from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const search = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/insurance-policies/search?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getById = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/insurance-policies/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const create = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).post('/api/insurance-policies', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const update = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put('/api/insurance-policies', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const makeActive = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/insurance-policies/${params}/active`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const makeInActive = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/insurance-policies/${params}/inactive`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListInsurancePolicy = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/select-lists/insurance-policies?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Insurance/api.js